import React from "react";

class HelpDesk extends React.Component {
  render() {
    return (
      <div className="full-page d-flex justify-content-center align-items-center">
        <div>
          <div className="title has-text-centered">
            <span className="zmdi zmdi-help"></span>
          </div>
          <div className="title has-text-centered">Help Desk</div>
          <div className="is-size-3 mt-4">
            Making Changes... Please check later.
          </div>
        </div>
      </div>
    );
  }
}

export default HelpDesk;
